export default __webpack_public_path__ + "static/media/warsztaty.b1504b85.jpg";